/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { clearErrors, updateApplication } from '@redux/modules/application/actions'
import env from 'config/environment'
import {
  didRouteChange,
  findPosition,
  parseFormUrl,
} from 'components/Navigation/navigation-helpers'
import SectionNotFound from 'components/Section/shared/SectionNotFound'
import { updateSection } from '@redux/modules/section/actions'
import { saveRequest } from '@redux/modules/save/actions'
import DebugRender from 'components/Debug/Render/DebugRender'
import { FeatureFlagProvider } from 'components/FeatureFlags/FeatureFlagProvider'
import featureFlags from '../../ff.json'
import Section from 'components/Section'
import { SavedIndicator } from 'components/SavedIndicator'
import TimeoutWarning from 'components/Form/TimeoutWarning'

// The concept is that we have three different inputs:
//  1. The index which just brings up the first entry of the form.
//  2. The section is known so we bring up that section and let
//     it handle what to display.
//  3. The section and subsection are known so the section will
//     display the subsection only.
export class Form extends React.Component {
  UNSAFE_componentWillMount() {
    this.defaultRedirect()

    // When the form is constructed, this will set the section and subsection.
    // This is useful for review pages, as they rely on "Subsection." Otherwise,
    // when the user reloads on a review page, the error list won't show up.
    // Supports EN-4499.
    const params = this.getParams()
    if (Object.keys(params).length > 0) {
      this.props.dispatch && this.props.dispatch(updateSection(params.section, params.subsection))
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    // didRouteChange was originally in "DidUpdate", but moved "WillUpdate"
    // modify the redux state at the parent level first, before the child
    // components. With the previous implementation, it was updating the child
    // components first (which were reporting valid errors) and by the time the
    // 'onRouteChanged' ran, it cleared out all errors and reported top-level
    // fields only.

    if (didRouteChange(this.props.location, nextProps.location)) {
      this.onRouteChanged(this.props, nextProps)
    }
  }

  /**
   * onRouteChanged will clearErrors and updateSection for the upcoming route.
   * It'll updateSettings, and from there, it'll initialize a save for the
   * previous route.
   *
   * @param {*} prevProps
   * @param {*} nextProps
   * @memberof Form
   */
  onRouteChanged(prevProps, nextProps) {
    // update the Redux store with the React Router state
    const params = this.getParams(nextProps)

    this.clearErrors(nextProps)
    this.props.dispatch(updateSection(params.section, params.subsection))

    this.updateSettings()

    // Original save functionality that is triggered on route change.
    // Now being triggered via saga (subsectionConnector)
    // Still needs to remain active until all the form elements/data are
    // handled inside the form state object
    this.save(prevProps.sectionKey, prevProps.subsectionKey)
  }

  getParams({ params, match } = this.props) {
    return params || match.params
  }

  getLocation({ location } = this.props) {
    return parseFormUrl(location.pathname)
  }

  defaultRedirect() {
    const params = this.getParams()

    if (!params.section) {
      const { history } = this.props
      history.push('/form/identification/intro')
    }
  }

  clearErrors(props = this.props) {
    const loc = this.getLocation(props)
    this.props.dispatch(clearErrors(loc.section, loc.subsection))
  }

  updateSettings() {
    this.props.dispatch(updateApplication('Settings', 'mobileNavigation', false))
  }

  save(sectionKey, subsectionKey) {
    const { dispatch } = this.props
    window.scroll(0, findPosition(document.getElementById('scrollTo')))

    dispatch(saveRequest(sectionKey, subsectionKey))
  }

  render() {
    const { showSessionWarning } = this.props

    const params = this.getParams()
    if (!params.section) {
      return null
    }

    return (
      <div id="eapp-form" className="eapp-form">
        <div id="info">
          {!params.subsection && <SectionNotFound />}
          <DebugRender parent={this} />
          <FeatureFlagProvider features={featureFlags.features}>
            <Section />
          </FeatureFlagProvider>
          <SavedIndicator interval={1000} />
          {showSessionWarning && <TimeoutWarning timeout={env.SessionTimeout()} />}
        </div>
      </div>
    )
  }
}

Form.propTypes = {
  location: PropTypes.object,
  dispatch: PropTypes.func,
  params: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  application: PropTypes.object,
  showSessionWarning: PropTypes.bool,

  authentication: PropTypes.bool,
  lastLogin: PropTypes.any,
  staticContext: PropTypes.any,
}

Form.defaultProps = {
  showSessionWarning: false,
}

export default withRouter(Form)
